import { render, staticRenderFns } from "./trafficCarList.vue?vue&type=template&id=3062024e&scoped=true"
import script from "./trafficCarList.vue?vue&type=script&lang=js"
export * from "./trafficCarList.vue?vue&type=script&lang=js"
import style0 from "./trafficCarList.vue?vue&type=style&index=0&id=3062024e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062024e",
  null
  
)

export default component.exports